import React from "react";
import { Box, Text, useBreakpoint } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { TbDeviceImacCode } from "react-icons/tb";

const Separator = () => {
  const rotateIn = keyframes`0%{
        opacity:0;
        transform:rotate3d(0,0,1,-200deg);
    }
    100%{
        opacity:1;
        transform:rotate3d(0,0,0);
    }
    `;
  return (
    <Box w="2rem" pos="relative" ml={12}>
      <Box h="495px" w="1px" bg="#e7eaec"></Box>
      <Box
        pos="absolute"
        top="0"
        left="-50%"
        w="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontSize="2rem"
        color={"rgb(94,234,212)"}
        bg="#000"
        animation={`${rotateIn} 1s linear`}
      >
        <TbDeviceImacCode />
      </Box>
    </Box>
  );
};

export default Separator;
